import VueI18n from 'vue-i18n'
import zh from './lang/zh'
import en from './lang/en' // 英语
import ru from './lang/ru' // 俄语
import es from './lang/es' // 西班牙语
import kz from './lang/kz' // 哈萨克语
import fr from './lang/fr' // 法语
import ara from "./lang/ara"; // 阿拉伯语
import de from "./lang/de" // 德语
import id from "./lang/id" // 印尼语
import jp from "./lang/jp"; // 日语
import kor from "./lang/kor"; // 韩语
import pu from "./lang/pu"; // 葡萄牙语
import per from "./lang/per"; // 波斯语
import pus from "./lang/pus" // 普什图语
import dari from "./lang/dari" // 达里语
import Vue from 'vue'
Vue.use(VueI18n)
let locale = 'en'
let messages = {
    zh,
    en,
    ru,
    es,
    de,
    kz,
    fr,
    ara,
    id,
    jp,
    kor,
    pu,
    per,
    pus,
    dari
}
export default new VueI18n({
    locale: locale,  // 语言标识
    messages: messages,
    silentTranslationWarn: true // 去除console中黄色报错
})
